// socketIOThunks.ts

import { createAsyncThunk } from "@reduxjs/toolkit";
import { io, Socket } from "socket.io-client";
import { setChatSocket } from "./webSocketSlice";

export const connectChatSocket = createAsyncThunk<void, string>(
  "socketIO/connectChatSocket",
  async (socketUrl, { dispatch }) => {
    try {
      const chatSocket = io(socketUrl);

      chatSocket.on("connect", () => {
        dispatch(setChatSocket(chatSocket)); // Dispatch the new action
      });
    } catch (error) {
      console.error("Error connecting to chat socket:", error);
    }
  }
);
